// module.exports = file => require('@/views/' + file + '.vue').default
module.exports = file => require('@/views/' + file).default



// WEBPACK FOOTER //
// ./src/router/import-development.js